import React from 'react';
import {MessagePopupButton} from '@gongxigames/framework/slot/types';
import {FlexBoxComponent} from '@gongxigames/framework/core/fragments/react';
import {MessagePopupButtonComponent} from './MessagePopupButtonComponent';

type MessageButtonsComponentProps = {
    buttons: MessagePopupButton[];
    gapBetweenButtons: number;
};

export const MessageButtonsComponent = (props: MessageButtonsComponentProps): JSX.Element | null => {
    const {buttons, gapBetweenButtons} = props;

    if (buttons.length === 0) {
        return null;
    }

    return (
        <FlexBoxComponent gap={gapBetweenButtons} >
            {buttons.map((btn, i) => <MessagePopupButtonComponent key={`ErrorPopupButton-${i}`} title={btn.title} action={btn.action} />)}
        </FlexBoxComponent>
    );
};
